import { createTableDefinitionObject } from '../SubSections/DPS/DPS.helpers';

export const TYPE = {
    NAME: 'NAME'
};

const functionalLocation = 'Functional Location';
export const tableDefinition = [
    createTableDefinitionObject('HdLocation', functionalLocation, '18%'),
    createTableDefinitionObject('DateTested', 'First Date Tested'),
    createTableDefinitionObject('CompletedBy', 'First Test Done By'),
    createTableDefinitionObject('HdLocationDescription', 'Location Description', '20%'),
    createTableDefinitionObject('LocationParent', 'Parent Location', '18%'),
    createTableDefinitionObject('TrfShortDesc', 'Test Record Form ID'),
];

export const tableDefinitionNonMo = [
    createTableDefinitionObject('HdLocation', functionalLocation),
    createTableDefinitionObject('MO', 'MO Number'),
    createTableDefinitionObject('CreatedDate', 'First Date Tested'),
    createTableDefinitionObject('CreatedBy', 'First Test Done By'),
    createTableDefinitionObject('TrfshortDesc', 'Test Record Form ID'),
];
const updateTableDefinition = (tableDef) => tableDef.map((row) => {
    if (row.columnTitle === functionalLocation) {
        return {
            ...row,
            displaySort: true
        };
    }
    if (row.columnTitle === 'Print Select All') {
        return {
            ...row,
            displayCheckBox: true
        };
    }
    return row;
});

export const updatedTableDefinition = updateTableDefinition(tableDefinition);
export const updatedTableDefinitionNonMo = updateTableDefinition(tableDefinitionNonMo);

export const TAGS_ACTIONS = {
    DESELECT_FILTERS: 'DESELECT_FILTERS',
    GET_TAGRECORDS_PENDING: 'GET_TAGRECORDS_PENDING',
    GET_TAGRECORDS_SUCCESS: 'GET_TAGRECORDS_SUCCESS',
    SET_TAGRECORD_ROW: 'SET_TAGRECORD_ROW',
    GET_SEARCHTAGRECORDS_PENDING: 'GET_SEARCHTAGRECORDS_PENDING',
    GET_SEARCHTAGRECORDS_SUCCESS: 'GET_SEARCHTAGRECORDS_SUCCESS',
    GET_SEARCHTAGRECORDS_FAILURE: 'GET_SEARCHTAGRECORDS_FAILURE',
    GET_SORTTAGRECORDS_PENDING: 'GET_SORTTAGRECORDS_PENDING',
    GET_SORTTAGRECORDS_SUCCESS: 'GET_SORTTAGRECORDS_SUCCESS',
    GET_SORTTAGRECORDS_FAILURE: 'GET_SORTTAGRECORDS_FAILURE',
    GET_TAGRECORDS_TOTALCOUNT: 'GET_TAGRECORDS_TOTALCOUNT',
    LOAD_FILTERS: 'LOAD_FILTERS',
    SET_TESTSTATUS_FILTERS: 'SET_TESTSTATUS_FILTERS',
    SET_FILTERS: 'SET_FILTERS',
    SET_CHECKBOX_FILTERS: 'SET_CHECKBOX_FILTERS',
    GET_SELECTEDROWTAGS: 'GET_SELECTEDROWTAGS',
    GET_TESTSTATUS_SELECTEDROWTAGS: 'GET_TESTSTATUS_SELECTEDROWTAGS',
    HDLOCATION_SORTORDER: 'HDLOCATION_SORTORDER',
    GET_TAGRECORDS_TOTALCOUNT_NONMO: 'GET_TAGRECORDS_TOTALCOUNT_NONMO',
    GET_SELECTEDROWTAGS_NONMO: 'GET_SELECTEDROWTAGS_NONMO',
    GET_TAGRECORDS_PENDING_NONMO: 'GET_TAGRECORDS_PENDING_NONMO',
    GET_TAGRECORDS_SUCCESS_NONMO: 'GET_TAGRECORDS_SUCCESS_NONMO',
    HDLOCATION_SORTORDER_NONMO: 'HDLOCATION_SORTORDER_NONMO',
    GET_SORTTAGRECORDS_PENDING_NONMO: 'GET_SORTTAGRECORDS_PENDING_NONMO',
    GET_SORTTAGRECORDS_SUCCESS_NONMO: 'GET_SORTTAGRECORDS_SUCCESS_NONMO',
    GET_SORTTAGRECORDS_FAILURE_NONMO: 'GET_SORTTAGRECORDS_FAILURE_NONMO',
    GET_SEARCHTAGRECORDS_PENDING_NONMO: 'GET_SEARCHTAGRECORDS_PENDING_NONMO',
    GET_SEARCHTAGRECORDS_SUCCESS_NONMO: 'GET_SEARCHTAGRECORDS_SUCCESS_NONMO',
    GET_SEARCHTAGRECORDS_FAILURE_NONMO: 'GET_SEARCHTAGRECORDS_FAILURE_NONMO',
    SET_NONMO_TAG_LIMIT_HOURS: 'SET_NONMO_TAG_LIMIT_HOURS'
};
